export const loading = (state = {show: false, text: ''}, action) => {
  switch (action.type) {
    case 'SHOW_LOADING':
      return {
        show: true,
        text: action.data,
      };
    case 'HIDE_LOADING':
      return {
        show: false,
        text: action.data,
      };
    case 'ERROR':
      return {
        show: false,
        text: '',
      };
    default:
      return state;
  }
};
